import { ISubmissionFile } from './submission';
import { ISubmissionWorkflowState } from './workflow-phase-ownership';

export const noteStatus = ['created', 'updated', 'deleted'] as const;
export type INoteStatus = (typeof noteStatus)[number];

// @deprecated - do not continue relying on NoteTargetTag. Use NoteCategory instead
export const NoteTargetTags = ['Decision Note', 'Permission Note'] as const;
export type ITargetTags = (typeof NoteTargetTags)[number] | (string & {});

export const noteTypes = ['user', 'journal'] as const;
export type INoteType = (typeof noteTypes)[number];
export const noteCategories = [
  'General',
  'Assessment',
  'Decision',
  'Permission'
] as const;
export type INoteCategory = (typeof noteCategories)[number];

export type TaggableEntity = {
  id: string;
  name: string;
  email: string;
  type: INoteType;
  shortname?: string;
  focusIssues?: {
    id: string;
    name: string;
    issueId: string;
    issueLink?: string;
    status: string;
  }[];
  description?: string;
  organizationId?: string;
  introduction?: string;
};

export type INoteAssessmentContextualInformation = {
  context: 'assessment';
  checklistCategory: string;
};

export type INoteDecisionContextualInformation = {
  context: 'decision';
  fromState: ISubmissionWorkflowState;
  toState: ISubmissionWorkflowState;
};

export type INoteContextualInformation =
  | INoteAssessmentContextualInformation
  | INoteDecisionContextualInformation;

export type INote = {
  id: string;
  status: INoteStatus;
  userId: string;
  submissionContextId: string;
  submissionId: string;
  title?: string;
  content?: string;
  mentions?: TaggableEntity[];
  targetTag?: ITargetTags;
  category: INoteCategory;
  parentNoteId?: string; // no use case currently
  contextualInformation?: INoteContextualInformation;
  targetPhase: string;
  modified_at: string;
  attachments?: ISubmissionFile[];
};
